module.exports = __webpack_public_path__ + "static/img/ipad.ae2ec54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ipad.png
// module id = B7jR
// module chunks = 1